import React from 'react'
import PropTypes from 'prop-types'
import Img from 'gatsby-image'
import { Card, CardFooter, Row, Col } from 'reactstrap'

const WorkCards = props => {
  const { alt, className, icons, imageURL, URL } = props

  const iconFooter = icons.map(icon => (
    <Col xs="2" key={icon.id}>
      <div className="thumbnail">
        <img src={icon.image} id="footer-icon" alt={icon.alt} />
      </div>
    </Col>
  ))

  return (
    <Card className={className}>
      <a href={URL} alt={alt} rel="noopener noreferrer" target="_blank">
        <Img fluid={imageURL} alt={alt} />
        <CardFooter>
          <Row>{iconFooter}</Row>
        </CardFooter>
      </a>
    </Card>
  )
}

WorkCards.propTypes = {
  imageURL: PropTypes.shape({}).isRequired,
  URL: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  icons: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default WorkCards
